<template>
  <navigation-menu-item target="balance" title="מצב העו״ש והאשראי"
                        v-on:navigate="$emit('navigate')"
                        icon="landmark"
                        :disabled="!allowNavigationToBalancePage" />
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import NavigationMenuItem from '../NavigationMenuItem.vue';

export default {
  name: 'BalancePageMenuItem',
  components: { NavigationMenuItem },
  computed: {
    ...mapState('credentials', ['credentialsList']),
    ...mapGetters('subscriptionState', ['hasAccessToCashflow']),
    ...mapState('applicationState', ['cashflowState']),
    ...mapGetters('applicationState', ['cashflowTypes']),
    allowNavigationToBalancePage() {
      return this.hasAccessToCashflow
        && !this.cashflowOutOfDate
        && !this.cashflowBlocked;
    },
    cashflowOutOfDate() {
      return this.cashflowState === this.cashflowTypes.OUT_OF_DATE;
    },
    cashflowBlocked() {
      return this.cashflowState === this.cashflowTypes.BLOCKED;
    },

  },
};
</script>

<style scoped lang="scss">
</style>
